import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getAddressDetails } from '../api-ts';

export function useGetPropertyDetails(address: string) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getPropertyDetails', address],
    queryFn: () => dispatch(getAddressDetails(address)),
    enabled: !!address,
  });
}
